const mutations = {
  setApplicationLoadingToTrue(state) {
    state.isApplicationLoading = true;
  },
  setApplicationLoadingToFalse(state) {
    state.isApplicationLoading = false;
  },
  setComponentLoadingTrue(state, property) {
    state.componentLoadings[`${property}`] = true;
  },
  setComponentLoadingFalse(state, property) {
    state.componentLoadings[`${property}`] = false;
  },
  setErrors(state, payload) {
    state.errors = [...state.errors, ...payload];
  }
};

export default mutations;
